<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="text-field">
      <mat-label>Введите тему</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="5"
        [formControlName]="fieldName"></textarea>
      <mat-error *ngIf="field!.errors?.required">{{
        requiredErrorMessage
      }}</mat-error>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-content-end">
    <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
      Отмена
    </button>

    <app-button-with-progress
      typeBtn="submit"
      [loading$]="loading$ | async"
      label="Сохранить"></app-button-with-progress>
  </mat-dialog-actions>
</form>
